module.exports = __webpack_public_path__ + "static/img/business78.b5c8bab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business78.png
// module id = f1Rx
// module chunks = 9